const AppLogo = ({ size = 24, className = '' }) => (
  <img
    src="/logo-icon.png"
    alt="FretManager"
    width={size}
    height={size}
    className={className}
    style={{ objectFit: 'contain', display: 'block' }}
  />
);

export default AppLogo;
